import {Controller} from "@hotwired/stimulus";
import Debug from 'debug';


export const name = 'mft';
const debug = Debug(`app:${name}`);

export default class ModalFrameTriggerController extends Controller<HTMLButtonElement> {

    static values = {
        id: {type: String, default: 'mft'},
        src: String,
        open: {type: Boolean, default: false},
        contentGrow: {type: Boolean, default: false},
    }

    click = () => {
        this.open(null);
    }

    connect() {
        this.element.addEventListener('click', this.click);
        if (this.element.dataset['open'] === 'true') {
            this.open(null);
        }
        debug('connect');
    }

    disconnect() {
        this.element.removeEventListener('click', this.click);
    }

    open(e) {
        const {src, contentGrow, frameId} = this.element.dataset;
        debug('src', src);

        window.modalFrame({id: frameId, src, contentGrow: Boolean(contentGrow)});
    }

}

